import type { BrandRequestsTab } from "@nlc/shared-types";

export type BrandRequestFilterId = BrandRequestsTab;

export const BRAND_REQUEST_FILTERS: {
  id: BrandRequestFilterId;
  label: string;
}[] = [
  { id: "approved", label: "Approved" },
  { id: "all", label: "All requests" },
  { id: "due-today", label: "Due today" },
  { id: "active", label: "Active" },
  { id: "queued", label: "Queued" },
];

export const DEFAULT_BRAND_REQUEST_FILTER: BrandRequestFilterId = "approved";
